import { useAuth } from '@clerk/clerk-react';
import { integrationsClient } from '../integrations.client';
export const useWhatsappClient = () => {
    const { getToken } = useAuth();
    const client = async () => integrationsClient(getToken, '/api/whatsapp');
    const saveIntegration = async (businessIdentity, code) => {
        try {
            const apiClient = await client();
            return await apiClient.post('/integrations', { businessIdentity, code });
        }
        catch (error) {
            console.error('Error saving WhatsApp integration:', error);
            throw error;
        }
    };
    const updateIntegration = async (safeIntegration) => {
        try {
            const apiClient = await client();
            return await apiClient.put('/integrations', { safeIntegration });
        }
        catch (error) {
            console.error('Error updating WhatsApp integration:', error);
            throw error;
        }
    };
    // Get current WhatsApp integrations
    const getIntegrations = async () => {
        try {
            const apiClient = await client();
            return await apiClient.get('/integrations');
        }
        catch (error) {
            console.error('Error fetching Whatsapp integrations:', error);
            throw error;
        }
    };
    // Disconnect WhatsApp integration
    const disconnectIntegration = async (whatsAppBusinessAccountId) => {
        try {
            const apiClient = await client();
            return await apiClient.delete(`/integrations/${whatsAppBusinessAccountId}`);
        }
        catch (error) {
            console.error('Error disconnecting WhatsApp integration:', error);
            throw error;
        }
    };
    return {
        getIntegrations,
        saveIntegration,
        updateIntegration,
        disconnectIntegration,
    };
};
